module.exports = function (f) {
  var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (img != '') {
    return "\n    <div class=\"welcome welcome-".concat(f, "\" style=\"background-image: url(").concat(img, ")\">\n      <div class=\"welcome-title\">").concat(title, "</div>\n      <div class=\"welcome-text\">").concat(text, "</div>\n    </div>\n  ");
  } else {
    return "\n    <div class=\"welcome welcome-".concat(f, "\">\n      <div class=\"welcome-title\">").concat(title, "</div>\n      <div class=\"welcome-text\">").concat(text, "</div>\n    </div>\n  ");
  }
};